import styled, { css } from 'styled-components';
import { getSpace } from '../../../foundation/theme/space.utils';
import { getFontWeight } from '../../../foundation/theme/typography.utils';
import tokens from '../../../foundation/tokens/js/tokens';
import { MAPPINGS_MODE } from './FormGroup.constants';
import { LABEL_SIZES_MAPPING } from './FormGroupLabel.constants';
// styled-components.
// -----------------------------------------------------------------------------
export const FormGroupLabelRoot = styled.label `
  ${({ position, size, theme }) => {
    const { fontSize, fontWeight } = LABEL_SIZES_MAPPING[position][size];
    return css `
      /* Fixed. */
      font-family: ${theme.typography.fontFamily};
      line-height: ${tokens.font.lineHeight.text.value};

      /* Variable. */
      font-size: ${fontSize};
      font-weight: ${fontWeight};
    `;
}}
`;
export const FormGroupDetails = styled.span `
  ${({ mode }) => {
    const { details } = MAPPINGS_MODE[mode];
    return css `
      color: ${details};
      display: inline-block;
      font-weight: ${getFontWeight('medium')};
      margin-left: ${getSpace('s')};
    `;
}}
`;
//# sourceMappingURL=FormGroupLabel.styled.js.map